import { u as useStateManager } from './useStateManager-7e1e8489.esm.js';
export { u as useStateManager } from './useStateManager-7e1e8489.esm.js';
import _extends from '../node_modules/@babel/runtime/helpers/esm/extends.js';
import * as React from 'react';
import { forwardRef } from 'react';
import { S as Select } from './Select-49a62830.esm.js';
export { c as createFilter, d as defaultTheme } from './Select-49a62830.esm.js';
import '../../@emotion/react/dist/emotion-react.esm.js';
import '../../../_virtual/stylis.js';
export { c as components } from './index-a301f526.esm.js';
import '../../../_virtual/objectSpread2.js';
import '../../../_virtual/slicedToArray.js';
import '../../../_virtual/objectWithoutProperties.js';
import '../../../_virtual/classCallCheck.js';
import '../../../_virtual/createClass.js';
import '../../../_virtual/inherits.js';
import '../../../_virtual/createSuper.js';
import '../../../_virtual/toConsumableArray.js';
import '../../../_virtual/typeof.js';
import '../../../_virtual/taggedTemplateLiteral.js';
import '../../../_virtual/defineProperty.js';
import 'react-dom';

var StateManagedSelect = /*#__PURE__*/forwardRef(function (props, ref) {
  var baseSelectProps = useStateManager(props);
  return /*#__PURE__*/React.createElement(Select, _extends({
    ref: ref
  }, baseSelectProps));
});
var StateManagedSelect$1 = StateManagedSelect;

export { StateManagedSelect$1 as default };
//# sourceMappingURL=react-select.esm.js.map
